import LastDayWorkingSummary from 'components/Dashboard/LastDayWorkingSummary'
import DailyPickSummary from 'components/Dashboard/DailyPickSummary'
import DailyAgroSummary from 'components/Dashboard/DailyAgroSummary'
import DailyPackingSummary from 'components/Dashboard/DailyPackingSummary'
import DailyAttendanceSummary from 'components/Dashboard/DailyAttendanceSummary'
import WeeklyPickSummary from 'components/Dashboard/WeeklyPickSummary'
import WeeklyAgroSummary from 'components/Dashboard/WeeklyAgroSummary'
import Leam from 'components/Dashboard/Leam'

import Settings from 'components/Management/Settings'
import WorkersManagement from 'components/Management/Workers'
import FarmingBlock from 'components/Management/FarmingBlock'
import Activities from 'components/Management/Activities'
import Devices from 'components/Management/Devices'
import Workdays from 'components/Management/Workdays'
import Stickers from 'components/Management/Stickers'
import Users from 'components/Management/Users'

export default {
  // dashboard routes
  'last-working-day-summary': LastDayWorkingSummary,
  'daily-pick-summary': DailyPickSummary,
  'daily-agro-summary': DailyAgroSummary,
  'daily-packing-summary': DailyPackingSummary,
  'daily-attendance-summary': DailyAttendanceSummary,
  'weekly-pick-summary': WeeklyPickSummary,
  'weekly-agro-summary': WeeklyAgroSummary,
  leam: Leam,

  // management routes
  settings: Settings,
  workers: WorkersManagement,
  'farming-block': FarmingBlock,
  activities: Activities,
  devices: Devices,
  workday: Workdays,
  stickers: Stickers,
  users: Users
}
